module.exports = __webpack_public_path__ + "static/media/get-involved--ways-montage.4a934917.png";